
















































import { Mixins, Component, Prop } from "vue-property-decorator";
import { EditorItemMixin } from "./mixins";
import { ModelEditableMixin } from "../../../system/mixins";
import { ReceptionDelivery } from "../../../../domain/workflow/reception";
import { ReceptionDeliveryKind } from "../../../../domain/workflow/items";

@Component({
  components: {
  }
})
export default class ReceptionDeliveryEditor extends Mixins(EditorItemMixin, ModelEditableMixin) {
  // ModelEditableMixinに実体あり
  editingSource: ReceptionDelivery;

  data(): any {
    return {
      initialDeliveryKind: null,
    };
  }
  initialDeliveryKind: ReceptionDeliveryKind;

  created(): void {
    this.initialDeliveryKind = this.editingSource.type.clone();
  }

  @Prop()
  generalFlagLabel: string;

  @Prop()
  isGeneralFlag1Enable: boolean;

  @Prop()
  deliveryKindList: ReceptionDeliveryKind[];

  get receptionDeliveryKindCode(): number {
    return this.editingSource.type.code;
  }

  set receptionDeliveryKindCode(value: number) {
    // codeしか書き換えていないので、POST時に名称は正しいものが格納されていない
    // バックエンドでは名称までは保存していないので何とか辻褄が合っている状態
    this.writeProperty((c: ReceptionDelivery) => c.type.code = value);
  }

  get generalFlag1(): boolean {
    return this.editingSource.generalFlag1;
  }

  set generalFlag1(value: boolean) {
    this.writeProperty((c: ReceptionDelivery) => c.generalFlag1 = value);
  }

  get zipCode(): string {
    return this.editingSource.zipCode;
  }

  set zipCode(value: string) {
    this.writeProperty((c: ReceptionDelivery) => c.zipCode = value);
  }

  get address(): string {
    return this.editingSource.address;
  }

  set address(value: string) {
    this.writeProperty((c: ReceptionDelivery) => c.address = value);
  }

  get note(): string {
    return this.editingSource.note;
  }

  set note(value: string) {
    this.writeProperty((c: ReceptionDelivery) => c.note = value);
  }

  checkDeliveryKindEnable(deliveryKind: ReceptionDeliveryKind): boolean {
    // isEnable=true もしく起動時の交付方法を表示
    return deliveryKind.isEnable || (this.initialDeliveryKind.code === deliveryKind.code);
  }

  searchWithZipCode(): void {
    this.$commonDialogs.postalAddress.picker.pick(this.zipCode, !this.address)
    .then(result => {
      if (!result) { return; }
      this.writeProperty((c: ReceptionDelivery) => {
        c.zipCode = result.postalCode;
        c.address = result.prefecture + result.municipality + result.area;
      });
    })
    .catch(e => {
      this.$error("郵便番号検索エラー", "郵便番号検索処理中にエラーが発生しました。", e);
    });
  }
}
